import React from "react";
import { motion } from "framer-motion";
import ProgressBar from "../components/ProgressBar";

import teachImg from "../images/teach_english.png"; // gambar besar

const Step8 = () => {
  const student = JSON.parse(localStorage.getItem("student"));
  
  // Menggunakan kunci yang benar dari localStorage
  const studentId = student?.student_id; 

  const handleSelect = async (value) => {
    if (!studentId) { // Cek studentId yang valid
      alert("Student data not found. Please login again.");
      window.location.href = "/login";
      return;
    }

    // --- LOGIKA REDIRECT KE UNDER CONSTRUCTION ---
    if (value === "no") {
      // Jika pengguna memilih 'No', simpan jawaban dan langsung redirect
      
      // Catatan: Jika Anda tidak perlu menyimpan jawaban 'no' ke database, 
      // Anda bisa langsung window.location.href = "/UnderConstruction"; di sini.
      // Namun, diasumsikan Anda tetap ingin menyimpan jawabannya ke DB.
      
      await updateDatabase(value, studentId);
      window.location.href = "/UnderConstruction"; // Redirect ke halaman Under Construction
      return; // Hentikan eksekusi
    }
    // ----------------------------------------------

    // Jika pengguna memilih 'Yes', lanjutkan ke step 9
    await updateDatabase(value, studentId);
    window.location.href = "/step9";
  };
  
  // Fungsi terpisah untuk mengurus operasi PUT ke Database (agar kode handleSelect lebih bersih)
  const updateDatabase = async (value, id) => {
    try {
      const response = await fetch(
        `http://localhost:3000/api/student-demography/${id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            teach_english: value,
            current_step: "9", // <----- TRACK STEP
          }),
        }
      );

      if (!response.ok) {
        alert("Failed to update your answer");
        return false;
      }
      
      // Update localStorage hanya jika penyimpanan ke DB berhasil
      const updatedStudent = {
        ...student,
        teach_english: value,
        current_step: "9",
      };
      localStorage.setItem("student", JSON.stringify(updatedStudent));
      
      return true;

    } catch (err) {
      console.error("Error updating:", err);
      alert("Server error");
      return false;
    }
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-start bg-blue-900 text-white relative">

      {/* Progress Bar */}
      <div className="w-full max-w-lg mt-6 z-20">
        <ProgressBar step={8} />
      </div>

      {/* IMAGE + TEXT */}
      <div className="relative mt-6">
        
        <img 
          src={teachImg}
          alt="Teach English"
          className="w-[340px] md:w-[420px] rounded-xl shadow-xl border-4 border-blue-700"
        />

        {/* Yellow Text Near the Interviewer */}
        <p
          className="
            absolute 
            font-extrabold 
            text-xl md:text-2xl
            left-20
            top-10 md:top-16
            drop-shadow-[0_0_6px_rgba(0,0,0,0.7)]
          "
          style={{ color: "#FFD900" }}  // warna kuning terang
        >
          Do You teach English?
        </p>

      </div>

      {/* YES / NO BUTTONS */}
      <div className="flex gap-6 mt-6">
        
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => handleSelect("yes")}
          className="bg-yellow-300 text-blue-900 font-bold px-10 py-3 rounded-full text-lg shadow-md"
        >
          Yes
        </motion.button>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={() => handleSelect("no")}
          className="bg-yellow-300 text-blue-900 font-bold px-10 py-3 rounded-full text-lg shadow-md"
        >
          No
        </motion.button>

      </div>

      {/* Footer */}
      <p className="absolute bottom-4 text-blue-200 text-xs">
        © 2025 Universitas Terbuka
      </p>

    </div>
  );
};

export default Step8;